<template>
  <div>
    <div class="overview-row flex-wrap flex-start hide-mobile">
      <div v-for="option in fullBookableTariffoptions" :key="option.tariffoptionId" @click="openModal(option)">
        <tariff-options-card :option="option" :current-tariff-id="currentTariffId"></tariff-options-card>
      </div>
    </div>
    <div v-if="fullBookableTariffoptions.length" class="hide-desktop">
      <VueSsrCarousel :slides-per-page="1" show-arrows peek-right="120" show-dots>
        <div class="slide" v-for="option in fullBookableTariffoptions" :key="option.tariffoptionId" @click="openModal(option)">
          <tariff-options-card :option="option" :current-tariff-id="currentTariffId"></tariff-options-card>
        </div>
      </VueSsrCarousel>
    </div>

    <CustomModal
      :visible="showModal"
      @close="showModal = false"
      :showNext="true"
      :showPrev="true"
      @prev="showModal = false"
      @next="detailsBookableAction(selectedDetails.tariffoptionId)"
    >
      <template slot="header">
        <div class="details-header" v-if="selectedDetails">
          <TariffOptionsIcon :value="!selectedDetails.flat ? selectedDetails.extraDataVolumes[0].primary : 'Flat'" />
          <h3 class="text-3xl">
            {{ selectedDetails.name }}
          </h3>

          <div class="flex-row text-base">
            <div>
              <h3 class="text-3xl">{{ selectedDetails.extraDataVolumes[0].primary }}</h3>
              <p class="text-sm">{{ selectedDetails.extraDataVolumes[0].secondary }}</p>
            </div>
            <div>
              <h3 class="text-3xl">{{ selectedDetails.formattedPrice }}</h3>
              <p class="text-sm">für {{ selectedDetails.duration.amount }} {{ selectedDetails.duration.formattedUnit }}</p>
            </div>
          </div>
        </div>
      </template>
      <template slot="default">
        <div class="text-base" v-if="selectedDetails" v-html="selectedDetails.details"></div>
      </template>
      <template slot="btnPrevTxt">
        <slot name="btnPrevTxt">Schließen</slot>
      </template>
      <template slot="btnNextTxt">
        <slot name="btnNextTxt">Jetzt kostenpflichtig buchen</slot>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'
import TariffOptionsCard from '@/components-v2/flows/LIDL/Tariff/generic/TariffOptions/TariffOptionsCard.vue'
import extraData from '@/mixins/extraData'
import joinTariffOptionsExtra from '@/helper/joinTariffOptionsExtras'
import transaction from '@/mixins/transaction'
import { mapActions, mapGetters } from 'vuex'
import VueSsrCarousel from 'vue-ssr-carousel'
import CustomModal from '@/components/generic/CustomModal.vue'
import TariffOptionsIcon from './TariffOptionsIcon.vue'

export default {
  name: 'TariffOptionsWrapperOverview',
  components: { TariffOptionsCard, VueSsrCarousel, CustomModal, TariffOptionsIcon },
  data() {
    return {
      selectedOptions: [],
      activeTariffoptionId: '',
      tariffoptions: {
        bookedTariffoptions: {
          bookedTariffoptions: []
        },
        bookableTariffoptions: {
          bookableTariffoptions: []
        }
      },
      serviceOptions: {
        tariffoptionId: ''
      },
      tariffs: {
        bookedTariff: {
          tariffId: ''
        }
      },
      showModal: false,
      selectedDetails: null
    }
  },
  computed: {
    fullBookedTariffoptions: function() {
      return this.tariffoptions.bookedTariffoptions.bookedTariffoptions
    },
    fullBookableTariffoptions: function() {
      return this.tariffoptions.bookableTariffoptions.bookableTariffoptions || []
    },
    fullBookableServiceoptions: function() {
      const option = {
        ...this.serviceOptions,
        tariffoptionId: 'so_acr'
      }
      return [option].map(serviceOption => {
        return joinTariffOptionsExtra(serviceOption, this.extraData)
      })
    },
    currentTariffId: function() {
      return this.tariffs.bookedTariff.tariffId
    },
    doubleDataPromo: function() {
      return ['CCS_92055', 'CCS_92056', 'CCS_92057']
    },
    ...mapGetters('bookTariffOptions', ['bookTariffoptionDocumentUrl'])
  },
  methods: {
    ...mapActions('bookTariffOptions', ['bookTariffoption', 'initiateCancelTariffOption', 'confirmTariffoption']),
    detailsBookedAction(optionId) {
      const option = this.fullBookedTariffoptions.find(op => {
        return op.tariffoptionId === optionId
      })
      if (
        option.automaticExtension === true &&
        option.cancelable === true &&
        option.statusKey !== 'TER' &&
        !this.doubleDataPromo.includes(optionId)
      ) {
        this.initiateCancelTariffOption({ tariffoptionId: optionId }).then(success => {
          if (success) {
            this.$refs.modalAction.showBookedModal(optionId, this.fullBookedTariffoptions, this.bookTariffoptionDocumentUrl)
          }
        })
      } else {
        this.$refs.modalAction.showBookedModal(optionId, this.fullBookedTariffoptions, null)
      }
    },
    detailsBookableAction(optionId) {
      if (this.selectedDetails == null) return

      this.bookTariffoption({ tariffoptionId: optionId }).then(response => {
        if (response.success === true) {
          // this.$refs.modalAction.showBookingModal(response, optionId, this.fullBookableTariffoptions)
          this.confirmTariffoption({}).then(
            () => {
              this.$emit('refresh')
              this.showModal = false
            },
            () => {
              this.showModal = false
            }
          )
        }
      })
    },
    detailsBookableServiceAction(optionId) {
      this.$refs.modalServiceAction.showBookableServiceModal(optionId, this.fullBookableServiceoptions)
    },
    refreshQuery() {
      this.$apollo.queries.tariffoptions.refetch()
    },
    openModal(details) {
      this.selectedDetails = details
      this.showModal = true
    }
  },
  apollo: {
    tariffoptions: function() {
      return wrapQuery(
        gql`
          query tariffOptions {
            tariffoptions {
              bookableTariffoptions {
                bookableTariffoptions {
                  bandwidth {
                    down
                    formattedUnit
                    up
                    unit
                  }
                  volumes {
                    formattedUnit
                    amount
                    type
                    unit
                  }
                  additionalInfo
                  automaticExtension
                  buttonText
                  details
                  formattedPrice
                  name
                  tariffoptionId
                  name
                  price
                  duration {
                    amount
                    unit
                    formattedUnit
                  }
                  notBookableWith
                  requiresContractSummary
                  extraDataVolumes {
                    primary
                    secondary
                  }
                  extraDataDescription
                  flat
                }
              }
              bookedTariffoptions {
                bookedTariffoptions {
                  bandwidth {
                    down
                    formattedUnit
                    up
                    unit
                  }
                  automaticExtension
                  tariffoptionId
                  name
                  price
                  duration {
                    amount
                    unit
                  }
                  statusKey
                  activeRuntime {
                    endOfRuntime
                    startOfRuntime
                  }
                  possibleChangingDate
                  buttonText
                  cancelable
                  formattedPrice
                  restrictedService
                  state
                }
              }
            }
          }
        `,
        this,
        'tariffoptions'
      )
    },
    serviceOptions: function() {
      return wrapQuery(
        gql`
          query serviceOptions {
            serviceOptions {
              anonymousCallRejection
            }
          }
        `,
        this,
        'serviceOptions'
      )
    },
    tariffs: function() {
      return wrapQuery(
        gql`
          query tariffs {
            tariffs {
              bookedTariff {
                tariffId
              }
            }
          }
        `,
        this,
        'tariffs'
      )
    }
  },
  mixins: [slotProxy(), extraData(), transaction('tariffOptions'), transaction('serviceOptions')]
}
</script>
